export const COLORS=["#f4f9f9",'#f6dfeb','#caf7e3','#fffdf9','#edffec','#ffe3ed','#8ac6d1','#e4bad4','#ccf2f4','#a4ebf3'];